<script lang="ts" setup>
const localePath = useLocalePath()
  definePageMeta({
    layout: 'auth'
  })

  const {t} = useI18n({
    useScope: 'global'
  })

  const submitHandler = async (formData, node) => {
    const client = useClient()
    try {
      node.setErrors(
        [],
      )
      const result = await client.auth.reset.mutate(formData)
    } catch (e) {
      node.setErrors(
        [e.message],
      )
      return false;
    }
  }
</script>

<template>
  <div>
    <FormKit
      id="reset"
      v-slot="{ value, disabled }"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <h2 class="form-title">
        {{ t('auth.reset.title') }}
      </h2>

      <FormKit
        type="text"
        name="username"
        :placeholder="t('common.labels.username')"
        validation="required"
      />

      <div class="form-nav">
        <div class="link">
          <NuxtLink :to="localePath('/auth/login')">
            {{ t('auth.reset.rememberPassword') }}
          </NuxtLink>
        </div>
      </div>

      <FormKit
        type="submit"
        width="full"
        :label="t('reset')"
      />
    </FormKit>
  </div>
</template>

<style scoped lang="scss">

  .form-title {
    font-weight: 700;
    font-size: 18px;
    text-align: center;
    margin-bottom: 30px;
  }

  .form-item {
    width: 100%;
    margin-bottom: 25px;
  }

  .form-nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin: 5px 0 30px;

    .link {
      font-size: 12px;
    }
  }

  .btn {
    width: 100%;
  }

</style>

<i18n>
{
  "en": {
    "reset": "Reset",
  }
}
</i18n>
